
<script>
import { mapGetters, mapActions } from 'vuex'

/**
 * Components
 *
 */
import DeleteDialog from '@/components/uicomp/ModalDialog-Delete'
import TableOptionsDialog from './ListOptionsDialog'
const components = {
  DeleteDialog,
  TableOptionsDialog,
}

/**
 * Static Data
 *
 */
const data = function () {
  return {
  }
}

/**
 * Computed
 *
 */
const computed = mapGetters({
  list: `Customer/list`,
  meta: `Customer/listMeta`,
})

/**
 * Methods
 *
 */
const methods = mapActions({
  setListOption: `Customer/setListOption`,
  reload: `Customer/fetchList`,
  pagePrev: `Customer/pagePrev`,
  pageNext: `Customer/pageNext`,
  deleteItem: `Customer/remove`,
})

methods.edit = function (id) {
  this.$router.push(`/customer/${id}`)
}

methods.showopt = function () {
  this.$refs.TableOptionsDialog.show()
}

methods.search = function (value) {
  this.setListOption({
    search: value,
    pagenumber: 1,
  })
}

/**
 * Watch
 *
 */
const watch = {
  meta: {
    deep: true,
    handler(n, o) {
      n.version !== o.version && this.reload()
    },
  }
}

/**
 * Event OnMounted
 *
 */
const mounted = async function() {
}

/**
 * Event OnCreated
 *
 */
const created = async function() {
  if (this.meta.filter.format !== `deep`) {
    this.setListOption({ format: `deep` })
  }
}

/**
 * Event Socket
 *
 */
const sockets = {
}

export default {
  components,
  data,
  computed,
  methods,
  watch,
  mounted,
  created,
  sockets,
}
</script>

<style scoped>
</style>

<template>
  <Row>
    <TableOptions
      :nrecord="meta.nrecord"
      :npage="meta.npage"
      :curpage="meta.curpage"
      :searchValue="meta.filter.search"
      @nextpage="pageNext"
      @prevpage="pagePrev"
      @showopt="showopt"
      @search="search"
    />
    <TableOptionsDialog ref="TableOptionsDialog"
    />

    <TableList>
      <template #head>
        <th width="40" class="text-center">#</th>
        <th width="200" class="text-left">Nama Pelanggan</th>
        <th width="120" class="text-left">Grup</th>
        <th class="text-left">Informasi</th>
        <th width="120" class="text-left">Belanja Terakhir</th>
        <th width="40" class="text-center">Harga Toko</th>
        <th width="40" class="text-right"></th>
      </template>

        <template #body>
        <tr v-for="(item, index) in list" :key="item.id">
          <td class="text-center" v-html="index + meta.curstart"></td>
          <td class="text-left">
            <router-link class="link underlined" :to="`/customer/${item.id}`">
              {{ item.name }}
            </router-link>
            <p class="subdata">{{ item.record_id }}</p>
          </td>
          <td class="text-left">
            {{ item.group_name }}
          </td>
          <td class="text-left">
            <p v-if="item.address">
              {{ item.address }}
              <br>
            </p>
            <fa-phone class="push-5-r"/> {{ item.phone }}
          </td>
          <td class="text-left">
            <!--  -->
          </td>
          <td class="text-center">
            <label class="label label-success" v-if="item.use_store_discount">Ya</label>
          </td>
          <td class="text-right">
            <TButtonDelete @click="$refs.DeleteDialog.confirm(item.id, item.name)" />
          </td>
        </tr>
      </template>
    </TableList>

    <DeleteDialog ref="DeleteDialog" @submit="deleteItem($event)" />
  </Row>
</template>